// extracted by mini-css-extract-plugin
module.exports = {"how-it-works-section":"HowItWorks_how-it-works-section__1_7v5"};